import { Component, computed, inject, Input, output } from '@angular/core'
import {
  CartItem,
  Experiment,
  getBucket,
  Product,
  ProductKey,
  ProductType,
} from '@naturalcycles/shared'
import {
  getAb344DiscountBucket,
  isAb344Test,
  isAb344Test2,
  isAb344TestActive,
} from '@src/ab-344/ab344-experiment.utils.js'
import { SubscriptionService } from '@src/app/core/services/subscription.service.js'
import { SignalStore } from '@src/app/core/store/signalStore.js'
import { LocalizePipe } from '@src/app/shared/pipes/localize.pipe.js'

interface CartItemAB344Configuration {
  shouldHideOuraDiscountItem: boolean
  isAB344Active: boolean
  hasBlueBackground: boolean
  priceText: string
}

@Component({
  selector: 'app-cart-item',
  templateUrl: './cart-item.component.html',
  styleUrls: ['./cart-item.component.scss'],
  standalone: false,
})
export class CartItemComponent {
  private subscriptionService = inject(SubscriptionService)
  private store = inject(SignalStore)
  private localizePipe = inject(LocalizePipe)

  private discountBucket = computed(() =>
    getAb344DiscountBucket(this.store.$experiment().assignments),
  )

  private isTestActive = computed(() => isAb344TestActive(this.discountBucket()))
  private isTest = computed(() => isAb344Test(this.discountBucket()))
  private isTest2 = computed(() => isAb344Test2(this.discountBucket()))

  protected isTest364 = computed(
    () =>
      getBucket(this.store.$experiment().assignments[Experiment.QUIZ_OURA_DISCOUNT_CHECKOUT]) ===
      'test',
  )

  @Input()
  protected item!: CartItem

  @Input()
  protected hasBTThermometerInCart = false

  @Input()
  protected nextRenewalProduct?: Product

  @Input()
  protected iconColor: 'default' | 'dark' = 'default'

  @Input()
  protected showPrice = true

  @Input()
  protected optional = false

  @Input()
  protected selected = false

  @Input()
  protected titleModifier?: string

  protected toggleSelected = output()
  protected ProductKey = ProductKey

  protected icon = computed(() => (this.iconColor === 'default' ? 'check-prosecco' : 'check'))

  protected nextRenewalProductDuration = computed(() =>
    this.nextRenewalProduct?.type === ProductType.SUBSCRIPTION
      ? this.subscriptionService.getDurationUnit(this.nextRenewalProduct)
      : undefined,
  )

  protected configuration = computed<CartItemAB344Configuration>(() => {
    const isBTDiscount =
      this.item?.key === ProductKey.BT_THERMOMETER && this.item?.price.discount === 100
    const isOuraDiscount = this.item?.key === ProductKey.OURA_RING_DISCOUNT

    return {
      shouldHideOuraDiscountItem: isOuraDiscount && this.isTest364(),
      isAB344Active: this.isTestActive(),
      hasBlueBackground: this.isTestActive() && isBTDiscount,
      priceText: this.getPriceText(isBTDiscount),
    }
  })

  private getPriceText(isBTDiscount: boolean): string {
    if (isBTDiscount) {
      if (this.isTest()) return '$0'
      if (this.isTest2()) return 'FREE'
    }
    return this.localizePipe.transform(this.item.price)
  }
}
